import { Link } from 'react-router-dom';

const links = [
    { title: 'Features', href: '/features' },
    { title: 'Privacy', href: '/privacy' },
    { title: 'Pricing', href: '/pricing' },
    { title: 'Contact', href: '/contact' },
    { title: 'Blog', href: '/blog' },
];

const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <img
        src="/logo.png"
        alt="BankConvert Logo"
        className="h-10 w-auto"
      />
      <span className="font-semibold text-xl" style={{ color: "#1e0d01", letterSpacing: "-0.5px" }}>
        BankConvert
      </span>
    </div>
  );
};

export default function FooterSection() {
    return (
        <footer className="py-12 sm:py-16 md:py-24 bg-white border-t border-[#1e0d01]/8">
            <div className="mx-auto max-w-[1160px] px-[30px]">
                <Link
                    to="/"
                    aria-label="go home"
                    className="mx-auto block w-fit">
                    <Logo />
                </Link>

                <div className="my-8 flex flex-wrap justify-center gap-6 text-sm">
                    {links.map((link, index) => (
                        <Link
                            key={index}
                            to={link.href}
                            className="font-medium transition-opacity hover:opacity-60 duration-150"
                            style={{ color: "rgba(30,13,1,0.5)" }}
                        >
                            {link.title}
                        </Link>
                    ))}
                </div>

                <div className="my-8 flex flex-wrap justify-center gap-4">
                    <a
                        href="https://x.com/elquaraoui"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="X/Twitter"
                        className="w-9 h-9 rounded-full border border-[#1e0d01]/15 flex items-center justify-center transition-colors hover:border-primary"
                        style={{ color: "rgba(30,13,1,0.5)" }}
                    >
                        <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M10.488 14.651L15.25 21h7l-7.858-10.478L20.93 3h-2.65l-5.117 5.886L8.75 3h-7l7.51 10.015L2.32 21h2.65zM16.25 19L5.75 5h2l10.5 14z" />
                        </svg>
                    </a>
                    <a
                        href="https://www.linkedin.com/in/zakaryaelquaroui"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        className="w-9 h-9 rounded-full border border-[#1e0d01]/15 flex items-center justify-center transition-colors hover:border-primary"
                        style={{ color: "rgba(30,13,1,0.5)" }}
                    >
                        <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93zM6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37z" />
                        </svg>
                    </a>
                    <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                        className="w-9 h-9 rounded-full border border-[#1e0d01]/15 flex items-center justify-center transition-colors hover:border-primary"
                        style={{ color: "rgba(30,13,1,0.5)" }}
                    >
                        <svg className="size-4" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95" />
                        </svg>
                    </a>
                </div>

                <p
                    className="block text-center text-sm"
                    style={{ color: "rgba(30,13,1,0.4)" }}
                >
                    © {new Date().getFullYear()} BankConvert, All rights reserved
                </p>
            </div>
        </footer>
    );
}
